export enum BusyIndicatorSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large'
}
